var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSocialInstagram20(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "New-Commbank-Footer",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "md---768---977---New-footer",
    transform: "translate(-504.000000, -448.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Instagram-icon",
    transform: "translate(504.000000, 448.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11,22 C17.0756115,22 22,17.0749647 22,11 C22,4.92503528 17.0756115,0 11,0 C4.92438852,0 0,4.92503528 0,11 C0,17.0749647 4.92438852,22 11,22",
    id: "Fill-1",
    fill: "#696968"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2890437,14.2496233 C15.2890437,14.8228987 14.8235364,15.288406 14.2496233,15.288406 L7.59605801,15.288406 C7.02278264,15.288406 6.55727538,14.8228987 6.55727538,14.2496233 L6.55727538,9.80944935 L8.17634788,9.80944935 C8.03605802,10.1537972 7.95762323,10.5293914 7.95762323,10.9228407 C7.95762323,12.5578552 9.28782616,13.8886958 10.9228407,13.8886958 C12.5584929,13.8886958 13.8886958,12.5578552 13.8886958,10.9228407 C13.8886958,10.5293914 13.8096233,10.1537972 13.6699712,9.80944935 L15.2890437,9.80944935 L15.2890437,14.2496233 Z M9.37518848,9.80944935 C9.72208703,9.32863775 10.2857972,9.01362325 10.9228407,9.01362325 C11.5598842,9.01362325 12.1235943,9.32863775 12.4704929,9.80944935 C12.6975074,10.1231885 12.8320581,10.5070726 12.8320581,10.9228407 C12.8320581,11.9750146 11.9756523,12.8314204 10.9228407,12.8314204 C9.87066675,12.8314204 9.01426093,11.9750146 9.01426093,10.9228407 C9.01426093,10.5070726 9.14944934,10.1231885 9.37518848,9.80944935 L9.37518848,9.80944935 Z M14.8509567,6.7498551 L15.0907248,6.74921741 L15.0907248,6.98771017 L15.0907248,8.58765223 L13.2580291,8.59339136 L13.25229,6.75495654 L14.8509567,6.7498551 Z M14.2496233,5.5 L7.59605801,5.5 C6.44057973,5.5 5.5,6.43994205 5.5,7.59605801 L5.5,9.80944935 L5.5,14.2496233 C5.5,15.4051016 6.44057973,16.3456814 7.59605801,16.3456814 L14.2496233,16.3456814 C15.4057393,16.3456814 16.3456814,15.4051016 16.3456814,14.2496233 L16.3456814,9.80944935 L16.3456814,7.59605801 C16.3456814,6.43994205 15.4057393,5.5 14.2496233,5.5 L14.2496233,5.5 Z",
    id: "Fill-4",
    fill: "#FEFEFE"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialInstagram20);
export default __webpack_public_path__ + "static/media/socialInstagram20.762e72330a808b3e61a995f48f9bbddc.svg";
export { ForwardRef as ReactComponent };